import { MaterialIcon, Texto, Horizontal } from '@gravitate-js/excalibrr'
import * as React from 'react'

/**
 * Cell renderer for carrier column
 * Shows carrier name with truck icon
 */
export function CarrierRenderer(params: any) {
  return (
    <Horizontal style={{ overflow: 'visible' }} gap={8} verticalCenter>
      <MaterialIcon icon='local_shipping' style={{ color: 'var(--theme-color-2)' }} />
      <Texto>{params.value}</Texto>
    </Horizontal>
  )
}
